import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import "../../style/Contact.css";
import { MDBBtn } from "mdbreact";
import { useToasts } from "react-toast-notifications";
import { Helmet } from "react-helmet";
import ReCAPTCHA from "react-google-recaptcha";

const API_URL = process.env.REACT_APP_API_URL;
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

function Contact() {
  const [email, setEmail] = useState();
  const [subject, setSubject] = useState();
  const [message, setMessage] = useState();
  const [disabledBtn, setDisabledBtn] = useState(false);
  const { addToast } = useToasts();
  const reRef = useRef();

  const TOKEN_KEY = "jwt";
  const loggedIn = useSelector((state) => state.login);
  const token = localStorage.getItem(TOKEN_KEY);

  useEffect(() => {
    function getEmailAddress() {
      axios
        .get(`${API_URL}/api/user/email`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => res.data)
        .then((data) => {
          setEmail(data);
        })
        .catch((e) => {
          if (e.response.status === 401) {
            setEmail("");
          }
        });
    }

    if (loggedIn) {
      getEmailAddress();
    }
  }, []);

  const submitEmail = async (e) => {
    e.preventDefault();
    setDisabledBtn(true);
    const tokenCaptcha = await reRef.current.executeAsync();

    axios
      .post(`${API_URL}/api/contact`, { email, subject, message, tokenCaptcha })
      .then((response) => {
        if (response.data.status === "success") {
          addToast("Message envoyé.", {
            appearance: "success",
            autoDismiss: true,
          });
          resetForm();
          setDisabledBtn(false);
        } else if (response.data.status === "fail") {
          addToast("Erreur lors de l'envoi du message.", {
            appearance: "error",
            autoDismiss: true,
          });
          setDisabledBtn(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const resetForm = () => {
    setEmail("");
    setSubject("");
    setMessage("");
  };

  return (
    <div className="contactMain">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Nous contacter</title>
      </Helmet>
      <h1>Nous contacter</h1>
      <form
        action=""
        method="post"
        className="contactForm"
        onSubmit={submitEmail}
      >
        <label for="email">Votre adresse mail :</label>
        <input
          placeholder="Entrez votre adresse mail"
          id="email"
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <label for="subject">Votre demande :</label>
        <select
          name="subject"
          id="subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        >
          <option value="fournisseur" selected="">
            Ajout / modification fournisseur
          </option>
          <option value="marque">Ajout / modification marque</option>
          <option value="mutuelle">Ajout / modification mutuelle</option>
          <option value="verrier">Ajout / modification verrier</option>
          <option value="autre">Autre</option>
        </select>
        <label for="message">Entrez votre message :</label>
        <textarea
          name="message"
          id="message"
          value={message}
          placeholder="Ce formulaire de contact est réservé aux opticiens afin de demander des modifications sur le site."
          rows="10"
          onChange={(e) => setMessage(e.target.value)}
        />
        <MDBBtn
          color="primary"
          type="submit"
          disabled={email ? disabledBtn : true}
        >
          Envoyer
        </MDBBtn>
      </form>
      <ReCAPTCHA sitekey={SITE_KEY} size="invisible" ref={reRef} hl="fr" />
    </div>
  );
}

export default Contact;
